import script from "./ProjectHasntModuleDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectHasntModuleDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProjectHasntModuleDialog.vue?vue&type=style&index=0&id=6cbc77a1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cbc77a1"]])

export default __exports__